module.exports = __webpack_public_path__ + "static/img/NzjLOGO.e781975.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/NzjLOGO.png
// module id = 9hqe
// module chunks = 1